import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import actionCreators from "./redux/actionCreators";
import { getExpandedPermissions, getInProgress, getRolesData } from "./redux/selectors";
import Roles from "./roles";
const canDelete = security.isAllowed([Permissions.RolesDelete]);
const canEdit = security.isAllowed([Permissions.RolesEdit]);
const mapStateToProps = (state) => ({
    data: getRolesData(state),
    inProgress: getInProgress(state),
    canDelete,
    canEdit,
    expandedPermissions: getExpandedPermissions(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => dispatch(actionCreators.getRoles()),
    onChangeExpandedPermissions: (expandedPermissions) => dispatch(actionCreators.setExpandedPermissions(expandedPermissions)),
    onDeleted: (ids) => dispatch(actionCreators.removeRoles(ids)),
    onSaveRole: (data, completed) => dispatch(actionCreators.saveRole(data, completed))
});
export default connect(mapStateToProps, mapDispatchToProps)(Roles);
